import { render, staticRenderFns } from "./ReportReleaseNote.vue?vue&type=template&id=290905b5&scoped=true"
import script from "./ReportReleaseNote.vue?vue&type=script&lang=js"
export * from "./ReportReleaseNote.vue?vue&type=script&lang=js"
import style0 from "./ReportReleaseNote.vue?vue&type=style&index=0&id=290905b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290905b5",
  null
  
)

export default component.exports